export const delay = duration =>
  new Promise(r => setTimeout(() => r(), duration));

export default function* Sagas() {
  // empty
}
